import { ExaminationInfoQuery } from "@generated/graphql";
import { useMemo } from "react";
import qs from "qs";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { getTrialLinkString } from "helpers/index";
import useIsCreate from "hooks/useIsCreate";
import { CompetencyMapOptionList } from "../../types";
import { GroupAndOpenInfoInputs } from "../types";
import { getExaminationIsExtendedReport } from "../../helpers";

const useInitBaseExaminationForm = (
  examination: ExaminationInfoQuery["examination"] | undefined,
  competencyMaps: CompetencyMapOptionList
): GroupAndOpenInfoInputs => {
  const [searchParams] = useSearchParams();
  const isCreate = useIsCreate();
  const params = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);
  const { competencyMapId } = params as unknown as { competencyMapId?: string };

  const competencyMap =
    isCreate && competencyMapId
      ? competencyMaps?.find((map) => map.id === competencyMapId)
      : examination?.competencyMap;
  const createdAt = examination?.createdAt;
  const assessmentLink = examination ? getTrialLinkString(examination) : undefined;

  return {
    id: examination?.id || "",
    title: examination?.title,
    createdAt: createdAt ? dayjs(createdAt).format("DD.MM.YYYY HH:mm") : "",
    competencyMap: competencyMap
      ? {
          id: competencyMap.id || "",
          title: competencyMap.title || "",
        }
      : null,
    competencyMapComment: competencyMap?.comment || "",
    competencyMapGrades: competencyMap?.grades?.join(", ") || "",
    link: assessmentLink,
    isSendResult: examination?.isSendResult === undefined ? true : examination.isSendResult,
    isExtendedReport: getExaminationIsExtendedReport(examination?.sendResultType),
  };
};

export default useInitBaseExaminationForm;
